var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7157 8.65582C21.8057 8.56587 21.8772 8.45905 21.926 8.34147C21.9748 8.22389 21.9999 8.09785 22 7.97056C22.0001 7.84326 21.9751 7.71719 21.9264 7.59955C21.8778 7.48191 21.8065 7.37501 21.7165 7.28494C21.6265 7.19487 21.5197 7.1234 21.4022 7.07461C21.2846 7.02582 21.1585 7.00067 21.0312 7.0006C20.904 7.00052 20.7779 7.02551 20.6602 7.07416C20.5426 7.1228 20.4357 7.19414 20.3456 7.28409L14.4999 13.13L8.6558 7.28409C8.4739 7.10219 8.22719 7 7.96994 7C7.7127 7 7.46599 7.10219 7.28409 7.28409C7.10219 7.466 7 7.71271 7 7.96996C7 8.22721 7.10219 8.47392 7.28409 8.65582L13.1299 14.5L7.28409 20.3442C7.19402 20.4342 7.12258 20.5412 7.07383 20.6589C7.02509 20.7765 7 20.9027 7 21.03C7 21.1574 7.02509 21.2835 7.07383 21.4012C7.12258 21.5189 7.19402 21.6258 7.28409 21.7159C7.46599 21.8978 7.7127 22 7.96994 22C8.09732 22 8.22345 21.9749 8.34112 21.9262C8.4588 21.8774 8.56573 21.806 8.6558 21.7159L14.4999 15.87L20.3456 21.7159C20.5275 21.8976 20.7742 21.9996 21.0312 21.9994C21.2883 21.9992 21.5348 21.897 21.7165 21.7151C21.8982 21.5332 22.0002 21.2865 22 21.0294C21.9998 20.7724 21.8976 20.5259 21.7157 20.3442L15.8699 14.5L21.7157 8.65582Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_Icon.e4e81eea5cd6b0e26b17a941bd3a095d.svg";
export { ForwardRef as ReactComponent };